import 'css-chunk:../authentication/frontend/pages/register-page/desktop.module.scss';export default {
  "desktop": "_desktop_1cuc1_2"
};